import React, { useState } from "react";
import "./Stats.scss";
import "../NavBar/NavBarTab/NavBarTab.scss";
import { TabMenu } from "primereact/tabmenu";
import Margin from "./Margin";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useFetchGet, useFetchGetConditional } from "Services/api";
import { useEffect } from "react";
import { updateOffers } from "Redux/Actions/offersActions";
import { updateUsers } from "Redux/Actions/usersActions";
import { updateSecondaryTables } from "Redux/Actions/secondaryTablesActions";
import OffresModule from "./Modules/Offres/OffresModule";
import EntreprisesModule from "./Modules/Entreprises/EntreprisesModule";
import UtilisateursModule from "./Modules/Utilisateurs/UtilisateursModule";
import MatomoModule from "./Modules/Matomo/MatomoModule";
import SuperAdminModule from "./Modules/SuperAdmin/SuperAdminModule";

/**
 * @typedef {Object} NivoChartData
 * @property {String} id - ID de l'élément
 * @property {String} label - Nom de l'élément
 * @property {Number} value - Nombre d'offres associées à cet élément
 */

/**
 * Le composant {@link Stats} est le point d'ancrage de la partie statistiques.
 * Il va définir le menu qui va permettre d'accéder aux différents modules,
 * définissant eux-mêmes d'autres composants.
 *
 *
 * Les différents modules étant :
 * - {@link OffresModule}
 * - {@link UtilisateursModule}
 * - {@link EntreprisesModule}
 * - {@link MatomoModule}
 *
 */

const Stats = (props) => {
  const [index, setIndex] = useState(0);

  // Récupération des données via l'api pour les données statistiques
  const offerCategoriesData = useFetchGetConditional(
    "/offer_categories",
    props.auth.token,
    props.secondaryTables.offerCategoriesData
  );
  const usersData = useFetchGet("/users", props.auth.token);

  useEffect(() => {
    offerCategoriesData.loaded &&
      props.handleUpdateSecondaryTables({
        offerCategoriesData: offerCategoriesData.data,
      });
  }, [offerCategoriesData.loaded]);

  const items = [
    { label: "Offres", icon: "pi pi-fw pi-folder" },
    { label: "Entreprises", icon: "pi pi-fw pi-building" },
    { label: "Utilisateurs", icon: "pi pi-fw pi-users" },
    { label: "Matomo", icon: "pi pi-fw pi-database" },
    // { label: "Superadmin", icon: "pi pi-fw pi-lock" },
  ];

  // on remplit le store redux avec les données récupérées de l'API
  useEffect(() => {
    props.handleUpdateOffers({
      statusData:
        props.states.statesData.length > 0 ? props.states.statesData : [],
    });
    props.handleUpdateUsers({
      usersData: usersData.loaded ? usersData.data : [],
    });
  }, [usersData.loaded, props.states.statesData.length]);

  return (
    <div className="stats_container">
      <div className="stats_container__title">
        <h1>
          <div className="trait_dessus"></div>
          Statistiques
        </h1>
      </div>
      <React.Fragment>
        <TabMenu
          className="stats_container__tabmenu"
          model={items}
          onTabChange={(e) => setIndex(e.index)}
          activeIndex={index}
        />
        <Margin position="bottom" size="xs" />

        {index === 0 && <OffresModule />}
        {index === 1 && <EntreprisesModule />}
        {index === 2 && <UtilisateursModule />}
        {index === 3 && <MatomoModule />}
        {index === 4 && <SuperAdminModule />}
      </React.Fragment>
    </div>
  );
};

Stats.propTypes = {
  offers: PropTypes.object,
  handleUpdateOffers: PropTypes.func,
  auth: PropTypes.object,
  users: PropTypes.object,
  states: PropTypes.object,
  handleUpdateUsers: PropTypes.func,
  secondaryTables: PropTypes.object,
  handleUpdateSecondaryTables: PropTypes.func,
};
const mapStateToProps = (state) => ({
  offers: state.offers,
  users: state.users,
  auth: state.auth,
  states: state.states,
  secondaryTables: state.secondaryTables,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateOffers: (value) => dispatch(updateOffers(value)),
  handleUpdateUsers: (value) => dispatch(updateUsers(value)),
  handleUpdateSecondaryTables: (value) => {
    dispatch(updateSecondaryTables(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Stats);
